import {
  Description as DescriptionIcon,
  Report as ReportIcon,
} from '@mui/icons-material';
import {
  Alert,
  AlertTitle,
  Box,
  Chip,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { formatDate } from 'lib/functions/utils';
import { Warranty } from 'lib/types/models';
import React from 'react';

export default function ClaimedWarrantyCard({
  warranty,
}: {
  warranty: Pick<Warranty, 'claimReason' | 'claimDate' | 'claimedBy'>;
}) {
  const claimedAt = warranty.claimDate
    ? formatDate(new Date(warranty.claimDate))
    : '-';
  const claimedBy = warranty.claimedBy?.name ?? '-';
  const claimReason = warranty.claimReason ?? '-';

  return (
    <Paper sx={{ p: 1.5, boxShadow: 'none', border: '1px solid #e0e0e0' }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
        <Box
          sx={{
            backgroundColor: 'error.main',
            borderRadius: '50%',
            p: 0.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
          }}
        >
          <ReportIcon sx={{ fontSize: '1rem' }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '1rem',
              lineHeight: 1.1,
            }}
          >
            Garantía Siniestrada
          </Typography>
          <Stack direction="row" spacing={0.5}>
            <Chip
              label={'Siniestro'}
              size="small"
              color="error"
              variant="outlined"
              sx={{ height: '18px', fontSize: '0.65rem' }}
            />
            <Chip
              label={`Fecha: ${claimedAt}`}
              size="small"
              color="default"
              sx={{ height: '18px', fontSize: '0.65rem' }}
            />
          </Stack>
        </Box>
      </Stack>

      <Stack
        direction="row"
        alignItems="start"
        justifyContent="space-between"
        sx={{ mb: 1 }}
      >
        <Stack direction="row" spacing={0.75} alignItems="center">
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: '0.75rem' }}
          >
            Siniestrado por
          </Typography>
          <Typography
            variant="body2"
            color="text.primary"
            sx={{ fontSize: '0.85rem', fontWeight: 600 }}
          >
            {claimedBy}
          </Typography>
        </Stack>
      </Stack>

      <Alert
        severity="error"
        icon={<DescriptionIcon sx={{ fontSize: '0.9rem' }} />}
        sx={{
          borderRadius: 0.5,
          backgroundColor: 'rgba(211, 47, 47, 0.08)',
          border: '1px solid rgba(211, 47, 47, 0.2)',
          py: 0.75,
          mt: 1,
          '& .MuiAlert-message': { py: 0.25 },
        }}
      >
        <AlertTitle sx={{ fontWeight: 600, fontSize: '0.75rem' }}>
          Motivo del siniestro
        </AlertTitle>
        <Typography
          variant="body2"
          sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}
        >
          {claimReason}
        </Typography>
      </Alert>
    </Paper>
  );
}
